import { fg } from '@atlaskit/platform-feature-flags';

import type { Trait, TraitsForContext } from '../types';

export const getSiteTraitValues = (traits: Trait[]): TraitsForContext => {
	if (traits.length === 0) {
		return {
			automationUsage: 0,
			lastAutomationFreeLimitBreachDate: null,
		};
	}

	const automationUsageTrait = traits.find(
		(trait) =>
			trait.name ===
			(fg('growth_automation_limits_traits_name_change')
				? 'growth_automation_limits_current_usage'
				: 'growth_automation_limits_usage'),
	);
	const lastAutomationFreeLimitBreachDateTrait = traits.find(
		(trait) => trait.name === 'growth_automation_limits_usage_latest_breach_date',
	);

	const automationUsage =
		automationUsageTrait &&
		automationUsageTrait.value !== undefined &&
		!isNaN(Number(automationUsageTrait.value))
			? Number(automationUsageTrait.value)
			: 0;

	const lastAutomationFreeLimitBreachDate =
		lastAutomationFreeLimitBreachDateTrait &&
		typeof lastAutomationFreeLimitBreachDateTrait.value === 'string' &&
		!isNaN(Date.parse(lastAutomationFreeLimitBreachDateTrait.value))
			? new Date(lastAutomationFreeLimitBreachDateTrait.value)
			: null;

	return {
		automationUsage,
		lastAutomationFreeLimitBreachDate,
	};
};
